/* unplugin-vue-components disabled */import { render } from "./Treaty.vue?vue&type=template&id=f12195f0&scoped=true"
const script = {}

import "./Treaty.vue?vue&type=style&index=0&id=f12195f0&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/yunibao-invite-h5-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12195f0"]])

export default __exports__